import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Component, Output, ViewChild, Input, NgModule } from '@angular/core';
import { pluck, map, take } from 'rxjs/operators';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { Subject, combineLatest } from 'rxjs';
import * as i2 from '@angular/router';
import * as i3 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i4 from 'ngx-clipboard';
import { ClipboardModule } from 'ngx-clipboard';
import * as i5 from 'ngx-toastr';
import * as i7 from '@ngrx/store';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i9 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i10 from 'primeng/chips';
import * as i11 from '@progress/kendo-angular-editor';
import { EditorModule } from '@progress/kendo-angular-editor';
import * as i12 from '@progress/kendo-angular-toolbar';
import * as i13 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i14 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i15 from 'primeng/checkbox';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { PrimengLibraryModule } from 'primeng-library';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PaginatorModule } from 'primeng/paginator';
import { ImageCropperModule } from 'ngx-image-cropper';

class LibTemplateBuilderService {
    constructor(http) {
        this.http = http;
    }
    getDataSourceList(dataSourceType) {
        return this.http.get(`/vd/dataSource/${dataSourceType}/elements`).pipe(pluck("data"), map((data) => {
            return data;
        }));
    }
    getPlaceholders(roleParam) {
        //const groupId = 1;
        const params = new HttpParams().set('placeHolderUI', roleParam);
        return this.http.get(`/vd/formBuilder/masterList/placeholders?`, { params }).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
}
LibTemplateBuilderService.ɵfac = function LibTemplateBuilderService_Factory(t) { return new (t || LibTemplateBuilderService)(i0.ɵɵinject(i1.HttpClient)); };
LibTemplateBuilderService.ɵprov = i0.ɵɵdefineInjectable({ token: LibTemplateBuilderService, factory: LibTemplateBuilderService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateBuilderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["templateheaderkendoeditor"];
const _c1 = ["templatecontentkendoeditor"];
const _c2 = ["templatefooterkendoeditor"];
const _c3 = ["templateEmailContentkendoeditor"];
const _c4 = ["templateEmailSignaturekendoeditor"];
const _c5 = ["f"];
function LibTemplateBuilderComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 72);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getGlobalErrorMessages("REQUIRED"), " ");
} }
function LibTemplateBuilderComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 72);
    i0.ɵɵtext(1, " Maximum limit exceeded ");
    i0.ɵɵelementEnd();
} }
function LibTemplateBuilderComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "label", 6);
    i0.ɵɵtext(2, "Client");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 73);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r2.clients);
} }
function LibTemplateBuilderComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "label", 6);
    i0.ɵɵtext(2, "Share Template with");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-multiSelect", 74);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r3.reportingManagers)("showToggleAll", false);
} }
function LibTemplateBuilderComponent_div_30_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 81);
    i0.ɵɵelementStart(1, "small", 82);
    i0.ɵɵtext(2, "Paste Now!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibTemplateBuilderComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 75);
    i0.ɵɵelementStart(2, "div", 76);
    i0.ɵɵelementStart(3, "label", 77);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 78);
    i0.ɵɵelementStart(6, "button", 79);
    i0.ɵɵlistener("cbOnSuccess", function LibTemplateBuilderComponent_div_30_Template_button_cbOnSuccess_6_listener($event) { i0.ɵɵrestoreView(_r13); const item_r9 = ctx.$implicit; const i_r10 = ctx.index; const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.copied($event, item_r9, i_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, LibTemplateBuilderComponent_div_30_span_7_Template, 3, 0, "span", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(item_r9.placeHolderName);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", ctx_r4.copiedIndex === item_r9.id ? "Copied" : "COPY");
    i0.ɵɵproperty("ngClass", ctx_r4.copiedIndex === item_r9.id ? "p-button-success" : "p-button-outlined")("cbContent", item_r9.tbColumnName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.copiedIndex === item_r9.id);
} }
function LibTemplateBuilderComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 83);
    i0.ɵɵtext(2, "No Results!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibTemplateBuilderComponent_div_120_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2, "Add & Select required Candidate Details from below ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibTemplateBuilderComponent_div_121_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelementContainerStart(1, 89);
    i0.ɵɵelementStart(2, "p-checkbox", 90);
    i0.ɵɵlistener("onChange", function LibTemplateBuilderComponent_div_121_div_2_Template_p_checkbox_onChange_2_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.CandidateSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const check_r15 = ctx.$implicit;
    const i_r16 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r16);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", check_r15.get("name").value)("value", check_r15.get("isActive").value);
} }
function LibTemplateBuilderComponent_div_121_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵelementStart(1, "div", 86);
    i0.ɵɵtemplate(2, LibTemplateBuilderComponent_div_121_div_2_Template, 3, 3, "div", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r8.selectedCandidateDetail.controls);
} }
class LibTemplateBuilderComponent {
    constructor(fb, router, route, dialog, clipboardService, toastr, apiService, store) {
        this.fb = fb;
        this.router = router;
        this.route = route;
        this.dialog = dialog;
        this.clipboardService = clipboardService;
        this.toastr = toastr;
        this.apiService = apiService;
        this.store = store;
        this.template = {
            templateType: 'HTML',
            clientId: ''
        };
        this.placeHolderNames = [];
        this.emailPlaceHolderNames = [];
        // visaType;
        // petitionType;
        this.showTempList = false;
        this.showPreview = false;
        this.previewLetter = '';
        this.destroy$ = new Subject();
        this.enableGeneareAndPreviewButton = false;
        // defaultFrom = '';
        this.defaultTo = '';
        this.isEmailToError = false;
        this.isEmailFromError = false;
        this.isEmailCCError = false;
        // toMailArray: any[];
        this.defaultLogo = '';
        this.clients = [];
        this.placeholders = [];
        this.templateTypes = [];
        this.reportingManagers = [];
        this.candidatePlaceholders = [];
        this.header = '';
        this.body = '';
        this.footer = '';
        this.emailBody = '';
        this.emailSignature = '';
    }
    ngOnInit() {
        var _a, _b;
        this.roleType = sessionStorage.getItem('roleName');
        this.roleId = sessionStorage.getItem('fbRoleId');
        this.userType = sessionStorage.getItem('userTypeRole');
        this.loadDropdownData();
        this.loadPlaceholders();
        this.templateForm = this.fb.group({
            id: new FormControl(null),
            templateType: new FormControl(null, Validators.required),
            clientId: new FormControl(null, ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'HR Template Builder' ? null : Validators.required),
            sharedWith: new FormControl(null, ((_b = this.formBuilderInfo) === null || _b === void 0 ? void 0 : _b.formName) === 'HR Template Builder' ? null : Validators.required),
            templateName: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
            emailFrom: new FormControl(null),
            emailTo: new FormControl(null, Validators.required),
            emailCC: new FormControl(null),
            emailSubject: new FormControl(null, Validators.required),
            emailTemplateContent: new FormControl(null, Validators.required),
            selectedCandidateDetail: this.fb.array([]),
            selectedCandidateDetails: new FormControl([]),
            searchEmailPlacehlder: new FormControl('')
        });
        // Add dataListForm to the group using fromGrpName as the control name
        this.group.addControl(this.inputParams.name, this.templateForm);
    }
    /* createCheckedCandidatesList(value): FormGroup{
        return this.fb.group({
          isActive: value.IsActive?value.IsActive:false,
            name: value.name,
            id: value.id,
            code:value.code
        });
    } */
    loadPlaceholders() {
        var _a;
        let params = ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'HR Template Builder' ? 'HR' : 'TA';
        this.apiService.getPlaceholders(params)
            .pipe(take(1))
            .subscribe((response) => {
            console.log(response);
            console.log(response[0].placeholders);
            this.emailPlaceHolderNames = response[0].placeholders;
        });
    }
    get selectedCandidateDetail() {
        return this.templateForm.get('selectedCandidateDetail');
    }
    // get selectedCandidateDetails() {
    //   return this.templateForm.get('selectedCandidateDetails') as FormArray;
    // }
    loadDropdownData() {
        combineLatest([
            //this.referenceLibraryService.getReferenceData('IMMTYP'),
            this.apiService.getDataSourceList('FB_TA_CLIENT_COMPANY_NAME'),
            this.apiService.getDataSourceList('FBTEMPLATETYPE'),
            this.apiService.getDataSourceList('FB_ONB_REPORTING_MANAGER'),
            this.apiService.getDataSourceList('FB_EMAIL_CLIENT_MGR'),
            this.apiService.getDataSourceList('FBHRTEMPLATETYPE')
        ])
            .pipe(take(1))
            .subscribe((response) => {
            var _a, _b, _c, _d;
            this.clients = response[0];
            this.templateTypes = ((_a = this.formBuilderInfo) === null || _a === void 0 ? void 0 : _a.formName) === 'HR Template Builder' ? response[4] : response[1]; //response[1]; 
            this.reportingManagers = response[2];
            this.candidatePlaceholders = response[3];
            let selectedCandidateDetails = [];
            //if (this.inputParams.value) {
            this.templateForm.patchValue(this.inputParams.value);
            var selectedCandidateDetail = this.templateForm.get("selectedCandidateDetail");
            if (((_d = (_c = (_b = this.inputParams) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.selectedCandidateDetails) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                this.candidatePlaceholders.filter((value, index) => {
                    if (this.inputParams.value.selectedCandidateDetails.includes(value.code)) {
                        this.selectedCandidateDetail.push(this.fb.group({
                            isActive: true,
                            name: value.name,
                            id: value.id,
                            code: value.code
                        }));
                        selectedCandidateDetails.push(value.code);
                    }
                    else {
                        this.selectedCandidateDetail.push(this.fb.group({
                            isActive: false,
                            name: value.name,
                            id: value.id,
                            code: value.code
                        }));
                    }
                });
                //   this.candidatePlaceholders.forEach((obj1,index1)=> {
                //     this.inputParams.value.selectedCandidateDetails.forEach((obj2,index2)=> {
                //      if(obj1.code.includes(obj2)) {
                //       this.selectedCandidateDetail.push(this.fb.group({
                //         isActive: true,
                //         name: obj1.name,
                //         id: obj1.id,
                //         code: obj1.code
                //       }));
                //       selectedCandidateDetails.push(obj1.code)
                //       }else{
                //         this.selectedCandidateDetail.push(this.fb.group({
                //           isActive: false,
                //           name: obj1.name,
                //           id: obj1.id,
                //           code: obj1.code
                //         }));
                //       }
                //     });
                //  });
                this.templateForm.get('selectedCandidateDetails').setValue(selectedCandidateDetails);
                this.isEditMode = true;
            }
            else {
                this.candidatePlaceholders.forEach(value => {
                    selectedCandidateDetail.push(this.fb.group({
                        isActive: value.IsActive ? value.IsActive : false,
                        name: value.name,
                        id: value.id,
                        code: value.code
                    }));
                });
                this.isEditMode = false;
            }
            this.templateForm.updateValueAndValidity();
            //}
        });
    }
    CandidateSelected(e) {
        // (
        //   this.templateForm.controls[
        //   "selectedCandidateDetails"
        //   ] as FormArray
        // ).clear();
        this.templateForm.get('selectedCandidateDetails').setValue([]);
        let selectedCandidateDetails = [];
        this.templateForm.get('selectedCandidateDetail').value.forEach(value => {
            if (value.isActive == true) {
                selectedCandidateDetails.push(value.code);
                /* this.selectedCandidateDetails.push(this.fb.group({
                  name: value.name,
                  id: value.id
                })) */
            }
        });
        this.templateForm.get('selectedCandidateDetails').setValue(selectedCandidateDetails);
    }
    ngAfterViewInit() {
        this.formChangesSubscription = this.templtForm.statusChanges.subscribe(() => {
            if (this.templtForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    copied(e, item, index) {
        this.toastr.info(`${item.placeHolderName} copied`);
        this.copiedIndex = item.id;
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onChangeTemplateType(e) {
        if (e.value !== 'CNDSUBMISSION') {
            this.templateForm.get('selectedCandidateDetail').setValue([]);
        }
    }
    validateEmailAddress(event, item) {
        let inValidEmail = false;
        if (event.value.match("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")) {
            inValidEmail = false;
        }
        else {
            inValidEmail = true;
        }
        switch (item) {
            case 'from':
                this.isEmailFromError = inValidEmail;
            case 'to':
                this.isEmailToError = inValidEmail;
                if (inValidEmail) {
                    this.templateForm.get('emailTo').value.pop();
                    // this.templateForm.get('emailTo').markAsDirty();
                    // this.templateForm.get('emailTo').setErrors({ 'incorrect': true});
                }
                else {
                    //this.templateForm.get('emailTo').setErrors(null);
                }
            case 'cc':
                this.isEmailCCError = inValidEmail;
                if (inValidEmail) {
                    this.templateForm.get('emailCC').value.pop();
                }
        }
        this.templateForm.updateValueAndValidity();
    }
    // clearEmailValidation(item){
    //   let emailArr = [];
    //   switch(item){
    //     case 'from':
    //       emailArr =  Object.assign([],this.templateForm.get('emailFrom').value);        
    //     case 'to':
    //       emailArr = Object.assign([],this.templateForm.get('emailTo').value); 
    //     case 'cc':
    //       emailArr =  Object.assign([],this.templateForm.get('emailCC').value);   
    //   }
    //   if(emailArr.length > 0){
    //       let inValid = false;
    //       emailArr.forEach(el => {
    //         if(!el.match("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")){
    //           inValid = true;
    //           return;
    //         }
    //       });
    //       if(inValid){
    //         this.setFieldInvalid(item);
    //       }else{
    //         this.setFieldValid(item);
    //       }
    //   }else{
    //     if(item == 'to'){
    //       this.templateForm.get('emailTo').setErrors(null);
    //       this.isEmailToError = false;
    //     }
    //     if(item == 'from'){
    //       this.templateForm.get('emailFrom').setErrors(null);
    //       this.isEmailFromError = false;
    //     }
    //     if(item == 'cc'){
    //       this.templateForm.get('emailCC').setErrors(null);
    //       this.isEmailCCError = false;
    //     }
    //   }
    // }
    // setFieldInvalid(item){
    //   if(item == 'to'){
    //     this.templateForm.get('emailTo').setErrors({ 'incorrect': true});
    //     this.isEmailToError = false;
    //   }
    //   if(item == 'from'){
    //     this.templateForm.get('emailFrom').setErrors({ 'incorrect': true});
    //     this.isEmailFromError = false;
    //   }
    //   if(item == 'cc'){
    //     this.templateForm.get('emailCC').setErrors({ 'incorrect': true});
    //     this.isEmailCCError = false;
    //   }
    //   this.templateForm.updateValueAndValidity();
    // }
    // setFieldValid(item){
    //   if(item == 'to'){
    //     this.templateForm.get('emailTo').setErrors(null);
    //     this.isEmailToError = false;
    //   }
    //   if(item == 'from'){
    //     this.templateForm.get('emailFrom').setErrors(null);
    //     this.isEmailFromError = false;
    //   }
    //   if(item == 'cc'){
    //     this.templateForm.get('emailCC').setErrors(null);
    //     this.isEmailCCError = false;
    //   }
    //   this.templateForm.updateValueAndValidity();
    // }
    ngOnDestroy() {
        if (this.formChangesSubscription) {
            this.formChangesSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    get filteredPlaceholderNamesList() {
        return this.searchPlacehlder ? this.placeHolderNames.filter(v => v.placeHolderDescription.toLowerCase().indexOf(this.searchPlacehlder.trim().toLowerCase()) > -1) : this.placeHolderNames;
    }
    get filteredEmailPlaceholdersList() {
        var _a;
        const searchValue = (_a = this.templateForm.get('searchEmailPlacehlder')) === null || _a === void 0 ? void 0 : _a.value;
        if (searchValue) {
            return this.emailPlaceHolderNames.filter(v => v.placeHolderName.toLowerCase().includes(searchValue.trim().toLowerCase()));
        }
        else {
            return this.emailPlaceHolderNames;
        }
    }
}
LibTemplateBuilderComponent.ɵfac = function LibTemplateBuilderComponent_Factory(t) { return new (t || LibTemplateBuilderComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.MatDialog), i0.ɵɵdirectiveInject(i4.ClipboardService), i0.ɵɵdirectiveInject(i5.ToastrService), i0.ɵɵdirectiveInject(LibTemplateBuilderService), i0.ɵɵdirectiveInject(i7.Store)); };
LibTemplateBuilderComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibTemplateBuilderComponent, selectors: [["lib-template-builder"]], viewQuery: function LibTemplateBuilderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
        i0.ɵɵviewQuery(_c1, 1);
        i0.ɵɵviewQuery(_c2, 1);
        i0.ɵɵviewQuery(_c3, 1);
        i0.ɵɵviewQuery(_c4, 1);
        i0.ɵɵviewQuery(_c5, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateheaderkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templatecontentkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templatefooterkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateEmailContentkendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateEmailSignaturekendoeditor = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templtForm = _t.first);
    } }, inputs: { inputParams: "inputParams", group: "group", formBuilderInfo: "formBuilderInfo" }, outputs: { templateheaderkendoeditor: "templateheaderkendoeditor", templatecontentkendoeditor: "templatecontentkendoeditor", templatefooterkendoeditor: "templatefooterkendoeditor", templateEmailContentkendoeditor: "templateEmailContentkendoeditor", templateEmailSignaturekendoeditor: "templateEmailSignaturekendoeditor" }, decls: 122, vars: 12, consts: [[1, "container-fluid"], [3, "formGroup"], [1, "row"], [1, "col-md-4"], [1, "form-row"], [1, "form-group", "col-12"], [1, "required"], ["type", "text", "formControlName", "templateName", "placeholder", "E.G., Welcome Email", "maxlength", "101", "required", "", 1, "im-input", "w-100"], ["class", "invalid-message", 4, "ngIf"], ["optionLabel", "name", "required", "", "placeholder", "Select", "formControlName", "templateType", "optionValue", "code", 1, "d-block", "w-100", 3, "options", "onChange"], ["class", "form-group col-12", 4, "ngIf"], [1, "form-row", 2, "position", "sticky", "top", "10px"], [1, "form-group", "col-md-12"], [1, "clipbaord-content", "w-100"], [1, "labelText", "mb-3"], [1, "text-secondary", "mt-2", "font12px"], ["type", "text", "name", "searchEmailPlacehlder", "formControlName", "searchEmailPlacehlder", "placeholder", "Search Place Holder", 1, "im-input", "w-100"], [1, "placeholder-list"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "col-md-8"], ["id", "templateBuilder", 1, "row", "title", "headerEditor", "fr-section-border"], [1, "col-md-12"], [1, "p-form-note"], ["formControlName", "emailTo", "separator", ",", "required", "", 1, "form-group", "col-12", 3, "allowDuplicate", "onAdd"], ["formControlName", "emailCC", "separator", ",", 1, "form-group", "col-12", 3, "allowDuplicate", "onAdd"], ["type", "text", "formControlName", "emailSubject", "placeholder", "Subject", "required", "", 1, "im-input", "w-100"], [1, "row", "title", "contentEditor", "fr-section-border"], [1, "col-12"], ["formControlName", "emailTemplateContent", 2, "max-height", "600px", "overflow", "auto", "height", "506px"], ["templateEmailContentkendoeditor", ""], ["kendoEditorBoldButton", ""], ["kendoEditorItalicButton", ""], ["kendoEditorUnderlineButton", ""], ["kendoEditorStrikethroughButton", ""], ["kendoEditorSubscriptButton", ""], ["kendoEditorSuperscriptButton", ""], ["kendoEditorAlignLeftButton", ""], ["kendoEditorAlignCenterButton", ""], ["kendoEditorAlignRightButton", ""], ["kendoEditorAlignJustifyButton", ""], ["kendoEditorFormat", ""], ["kendoEditorFontSize", ""], ["kendoEditorFontFamily", ""], ["kendoEditorForeColor", ""], ["kendoEditorBackColor", "", "view", "gradient"], ["kendoEditorInsertUnorderedListButton", ""], ["kendoEditorInsertOrderedListButton", ""], ["kendoEditorIndentButton", ""], ["kendoEditorOutdentButton", ""], ["kendoEditorBlockquoteButton", ""], ["kendoEditorSelectAllButton", ""], ["kendoEditorUndoButton", ""], ["kendoEditorRedoButton", ""], ["kendoEditorCreateLinkButton", ""], ["kendoEditorUnlinkButton", ""], ["kendoEditorInsertFileButton", ""], ["kendoEditorViewSourceButton", ""], ["kendoEditorCleanFormattingButton", ""], ["kendoEditorAddColumnBeforeButton", ""], ["kendoEditorAddColumnAfterButton", ""], ["kendoEditorAddRowBeforeButton", ""], ["kendoEditorAddRowAfterButton", ""], ["kendoEditorDeleteColumnButton", ""], ["kendoEditorDeleteRowButton", ""], ["kendoEditorDeleteTableButton", ""], ["kendoEditorMergeCellsButton", ""], ["kendoEditorSplitCellButton", ""], ["kendoEditorPrintButton", ""], ["kendoEditorInsertImageButton", ""], ["class", "col-12 mt-4", 4, "ngIf"], ["class", "col-12 mt-4 mb-2", 4, "ngIf"], [1, "invalid-message"], ["optionLabel", "name", "required", "", "placeholder", "Select", "formControlName", "clientId", "optionValue", "code", 1, "d-block", "w-100", 3, "options"], ["optionLabel", "name", "required", "", "placeholder", "Select", "formControlName", "sharedWith", "optionValue", "code", 1, "d-block", "w-100", 3, "options", "showToggleAll"], [1, "row", "mt-1"], [1, "col-9", "mx-0", "px-0", "float-left"], ["clas", "d-block text-secondary"], [1, "col", "mx-0", "px-0", "float-right"], ["type", "button", "pButton", "", "ngxClipboard", "", 1, "ml-1", "copyButton", 3, "ngClass", "cbContent", "label", "cbOnSuccess"], ["class", "pl-1", 4, "ngIf"], [1, "pl-1"], [1, "text-secondary"], [1, "text-center", "d-block"], [1, "col-12", "mt-4"], [1, "col-12", "mt-4", "mb-2"], ["formArrayName", "selectedCandidateDetail", 1, "row"], ["class", "col-2 p-1", 4, "ngFor", "ngForOf"], [1, "col-2", "p-1"], [3, "formGroupName"], ["formControlName", "isActive", "name", "checkVal", "binary", "true", 3, "label", "value", "onChange"]], template: function LibTemplateBuilderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "form", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6, "Select the following details for the template");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "label", 6);
        i0.ɵɵtext(10, "Template Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "input", 7);
        i0.ɵɵtemplate(12, LibTemplateBuilderComponent_span_12_Template, 2, 1, "span", 8);
        i0.ɵɵtemplate(13, LibTemplateBuilderComponent_span_13_Template, 2, 0, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 5);
        i0.ɵɵelementStart(15, "label", 6);
        i0.ɵɵtext(16, "Template Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "p-dropdown", 9);
        i0.ɵɵlistener("onChange", function LibTemplateBuilderComponent_Template_p_dropdown_onChange_17_listener($event) { return ctx.onChangeTemplateType($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, LibTemplateBuilderComponent_div_18_Template, 4, 1, "div", 10);
        i0.ɵɵtemplate(19, LibTemplateBuilderComponent_div_19_Template, 4, 2, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 11);
        i0.ɵɵelementStart(21, "div", 12);
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelementStart(23, "h5", 14);
        i0.ɵɵtext(24, "Place Holders");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "small", 15);
        i0.ɵɵtext(26, "Click to Copy Paste the requires Place holders");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(27, "input", 16);
        i0.ɵɵelement(28, "hr");
        i0.ɵɵelementStart(29, "div", 17);
        i0.ɵɵtemplate(30, LibTemplateBuilderComponent_div_30_Template, 8, 5, "div", 18);
        i0.ɵɵtemplate(31, LibTemplateBuilderComponent_div_31_Template, 3, 0, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 20);
        i0.ɵɵelementStart(33, "div");
        i0.ɵɵelementStart(34, "p");
        i0.ɵɵtext(35, "Create your own template by adding the content(");
        i0.ɵɵelementStart(36, "small");
        i0.ɵɵtext(37, "Select the required template attributes on the left hand side to proceed");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(38, ")");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 21);
        i0.ɵɵelementStart(40, "div", 22);
        i0.ɵɵelementStart(41, "div", 4);
        i0.ɵɵelementStart(42, "label", 6);
        i0.ɵɵtext(43, "To ");
        i0.ɵɵelementStart(44, "small", 23);
        i0.ɵɵtext(45, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "p-chips", 24);
        i0.ɵɵlistener("onAdd", function LibTemplateBuilderComponent_Template_p_chips_onAdd_46_listener($event) { return ctx.validateEmailAddress($event, "to"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 22);
        i0.ɵɵelementStart(48, "div", 4);
        i0.ɵɵelementStart(49, "label");
        i0.ɵɵtext(50, "CC ");
        i0.ɵɵelementStart(51, "small", 23);
        i0.ɵɵtext(52, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "p-chips", 25);
        i0.ɵɵlistener("onAdd", function LibTemplateBuilderComponent_Template_p_chips_onAdd_53_listener($event) { return ctx.validateEmailAddress($event, "cc"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 22);
        i0.ɵɵelementStart(55, "div", 4);
        i0.ɵɵelementStart(56, "div", 12);
        i0.ɵɵelementStart(57, "label", 6);
        i0.ɵɵtext(58, "Subject");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(59, "input", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(60, "div", 27);
        i0.ɵɵelementStart(61, "div", 22);
        i0.ɵɵelementStart(62, "div", 2);
        i0.ɵɵelementStart(63, "div", 28);
        i0.ɵɵelementStart(64, "h5", 6);
        i0.ɵɵtext(65, "Email Content Section");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "div", 28);
        i0.ɵɵelementStart(67, "kendo-editor", 29, 30);
        i0.ɵɵelementStart(69, "kendo-toolbar");
        i0.ɵɵelementStart(70, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(71, "kendo-toolbar-button", 31);
        i0.ɵɵelement(72, "kendo-toolbar-button", 32);
        i0.ɵɵelement(73, "kendo-toolbar-button", 33);
        i0.ɵɵelement(74, "kendo-toolbar-button", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(75, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(76, "kendo-toolbar-button", 35);
        i0.ɵɵelement(77, "kendo-toolbar-button", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(79, "kendo-toolbar-button", 37);
        i0.ɵɵelement(80, "kendo-toolbar-button", 38);
        i0.ɵɵelement(81, "kendo-toolbar-button", 39);
        i0.ɵɵelement(82, "kendo-toolbar-button", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(83, "kendo-toolbar-dropdownlist", 41);
        i0.ɵɵelement(84, "kendo-toolbar-dropdownlist", 42);
        i0.ɵɵelement(85, "kendo-toolbar-dropdownlist", 43);
        i0.ɵɵelement(86, "kendo-toolbar-colorpicker", 44);
        i0.ɵɵelement(87, "kendo-toolbar-colorpicker", 45);
        i0.ɵɵelementStart(88, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(89, "kendo-toolbar-button", 46);
        i0.ɵɵelement(90, "kendo-toolbar-button", 47);
        i0.ɵɵelement(91, "kendo-toolbar-button", 48);
        i0.ɵɵelement(92, "kendo-toolbar-button", 49);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(93, "kendo-toolbar-button", 50);
        i0.ɵɵelement(94, "kendo-toolbar-button", 51);
        i0.ɵɵelementStart(95, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(96, "kendo-toolbar-button", 52);
        i0.ɵɵelement(97, "kendo-toolbar-button", 53);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(98, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(99, "kendo-toolbar-button", 54);
        i0.ɵɵelement(100, "kendo-toolbar-button", 55);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(101, "kendo-toolbar-button", 56);
        i0.ɵɵelement(102, "kendo-toolbar-button", 57);
        i0.ɵɵelement(103, "kendo-toolbar-button", 58);
        i0.ɵɵelement(104, "kendo-editor-insert-table-button");
        i0.ɵɵelementStart(105, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(106, "kendo-toolbar-button", 59);
        i0.ɵɵelement(107, "kendo-toolbar-button", 60);
        i0.ɵɵelement(108, "kendo-toolbar-button", 61);
        i0.ɵɵelement(109, "kendo-toolbar-button", 62);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(110, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(111, "kendo-toolbar-button", 63);
        i0.ɵɵelement(112, "kendo-toolbar-button", 64);
        i0.ɵɵelement(113, "kendo-toolbar-button", 65);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(114, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(115, "kendo-toolbar-button", 66);
        i0.ɵɵelement(116, "kendo-toolbar-button", 67);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(117, "kendo-toolbar-button", 68);
        i0.ɵɵelementStart(118, "kendo-toolbar-buttongroup");
        i0.ɵɵelement(119, "kendo-toolbar-button", 69);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(120, LibTemplateBuilderComponent_div_120_Template, 3, 0, "div", 70);
        i0.ɵɵtemplate(121, LibTemplateBuilderComponent_div_121_Template, 3, 1, "div", 71);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_10_0 = null;
        let tmp_11_0 = null;
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.templateForm);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngIf", (ctx.templateForm == null ? null : ctx.templateForm.get("templateName").touched) && (ctx.templateForm == null ? null : ctx.templateForm.get("templateName").errors == null ? null : ctx.templateForm.get("templateName").errors.required));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ((ctx.templateForm == null ? null : ctx.templateForm.get("templateName").dirty) || (ctx.templateForm == null ? null : ctx.templateForm.get("templateName").touched)) && (ctx.templateForm == null ? null : ctx.templateForm.get("templateName").errors == null ? null : ctx.templateForm.get("templateName").errors.maxlength));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.templateTypes);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams.name !== "HR_INV_TEMPLATE_BUILDER");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams.name !== "HR_INV_TEMPLATE_BUILDER");
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngForOf", ctx.filteredEmailPlaceholdersList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.filteredEmailPlaceholdersList.length);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("allowDuplicate", false);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("allowDuplicate", false);
        i0.ɵɵadvance(67);
        i0.ɵɵproperty("ngIf", (ctx.templateForm == null ? null : (tmp_10_0 = ctx.templateForm.get("templateType")) == null ? null : tmp_10_0.value) === "CNDSUBMISSION");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.templateForm == null ? null : (tmp_11_0 = ctx.templateForm.get("templateType")) == null ? null : tmp_11_0.value) === "CNDSUBMISSION");
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i1$1.MaxLengthValidator, i1$1.RequiredValidator, i8.NgIf, i9.Dropdown, i8.NgForOf, i10.Chips, i11.EditorComponent, i12.ToolBarComponent, i12.ToolBarButtonGroupComponent, i12.ToolBarButtonComponent, i11.EditorBoldButtonDirective, i11.EditorItalicButtonDirective, i11.EditorUnderlineButtonDirective, i11.EditorStrikethroughButtonDirective, i11.EditorSubscriptButtonDirective, i11.EditorSuperscriptButtonDirective, i11.EditorAlignLeftButtonDirective, i11.EditorAlignCenterButtonDirective, i11.EditorAlignRightButtonDirective, i11.EditorAlignJustifyButtonDirective, i11.EditorFormatComponent, i11.EditorFontSizeComponent, i11.EditorFontFamilyComponent, i11.EditorColorPickerComponent, i11.EditorForeColorDirective, i11.EditorBackColorDirective, i11.EditorInsertUnorderedListButtonDirective, i11.EditorInsertOrderedListButtonDirective, i11.EditorIndentButtonDirective, i11.EditorOutdentButtonDirective, i11.EditorBlockquoteDirective, i11.EditorSelectAllButtonDirective, i11.EditorUndoButtonDirective, i11.EditorRedoButtonDirective, i11.EditorCreateLinkButtonDirective, i11.EditorUnlinkButtonDirective, i11.EditorInsertFileButtonDirective, i11.EditorViewSourceButtonDirective, i11.EditorCleanFormattingButtonDirective, i11.EditorInsertTableButtonComponent, i11.EditorAddColumnBeforeButtonDirective, i11.EditorAddColumnAfterButtonDirective, i11.EditorAddRowBeforeButtonDirective, i11.EditorAddRowAfterButtonDirective, i11.EditorDeleteColumnButtonDirective, i11.EditorDeleteRowButtonDirective, i11.EditorDeleteTableButtonDirective, i11.EditorMergeCellsButtonDirective, i11.EditorSplitCellButtonDirective, i11.EditorPrintDirective, i11.EditorInsertImageButtonDirective, i13.MultiSelect, i14.ButtonDirective, i4.ClipboardDirective, i8.NgClass, i1$1.FormArrayName, i1$1.FormGroupName, i15.Checkbox], styles: [".title[_ngcontent-%COMP%]{width:100%;margin-bottom:30px}.title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#67617e;padding:10px 0}.btn-css[_ngcontent-%COMP%]{padding:5px 10px;float:right;margin:8px 0}.clipbaord-content[_ngcontent-%COMP%]{padding:10px;border:1px solid #c3d0de!important}.clipbaord-content[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{text-align:left;height:13px!important}[_nghost-%COMP%]     .p-button .p-button-success .p-button-outlined{padding:0 3 0 3px!important;height:20px!important;min-width:10px!important}.font12px[_ngcontent-%COMP%]{font-size:12px}.back-link[_ngcontent-%COMP%]{padding-top:12px!important;padding-bottom:12px!important;text-decoration:none!important}.im-btn.im-btn-primary[_ngcontent-%COMP%]:hover{background-color:#fff!important;border:1px solid #19a0da!important;border-radius:4px!important;font-size:14px!important;text-transform:uppercase;color:#10a0da!important}.im-btn.im-btn-primary[_ngcontent-%COMP%]:disabled, .im-btn.im-btn-primary[_ngcontent-%COMP%]:disabled:hover{background-color:#f0f0f0!important;color:#a3a6b4!important;font-size:14px!important;font-family:Source Sans Pro;border:1px solid transparent!important}[_nghost-%COMP%]     .fr-toolbar.fr-top{border-radius:0 0 0 0!important;border:1px solid #c3d0de!important}[_nghost-%COMP%]     .fr-wrapper{border:unset!important}[_nghost-%COMP%]     .fr-second-toolbar{border-radius:0 0 0 0!important;border:unset!important}.fr-section-border[_ngcontent-%COMP%]{box-shadow:0 2px 4px rgba(0,0,0,.1)!important}.im-btn.im-btn-primary.im-btn-md[_ngcontent-%COMP%]:focus{background-color:transparent!important}.placeholder-list[_ngcontent-%COMP%]{width:100%;height:350px;overflow-y:auto;margin-bottom:20px;font-size:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateBuilderComponent, [{
        type: Component,
        args: [{
                selector: 'lib-template-builder',
                templateUrl: './lib-template-builder.component.html',
                styleUrls: ['./lib-template-builder.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.Router }, { type: i2.ActivatedRoute }, { type: i3.MatDialog }, { type: i4.ClipboardService }, { type: i5.ToastrService }, { type: LibTemplateBuilderService }, { type: i7.Store }]; }, { templateheaderkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templateheaderkendoeditor"]
        }], templatecontentkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templatecontentkendoeditor"]
        }], templatefooterkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templatefooterkendoeditor"]
        }], templateEmailContentkendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templateEmailContentkendoeditor"]
        }], templateEmailSignaturekendoeditor: [{
            type: Output
        }, {
            type: ViewChild,
            args: ["templateEmailSignaturekendoeditor"]
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formBuilderInfo: [{
            type: Input
        }], templtForm: [{
            type: ViewChild,
            args: ['f', { static: false }]
        }] }); })();

class LibTemplateBuilderModule {
}
LibTemplateBuilderModule.ɵfac = function LibTemplateBuilderModule_Factory(t) { return new (t || LibTemplateBuilderModule)(); };
LibTemplateBuilderModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibTemplateBuilderModule });
LibTemplateBuilderModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            ImageCropperModule,
            MatIconModule,
            DropdownModule,
            DialogModule,
            ButtonModule,
            PaginatorModule,
            MultiSelectModule,
            InputTextareaModule,
            MatExpansionModule,
            ConfirmDialogModule,
            AccordionModule,
            MatDatepickerModule,
            DeleteDialogLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatSelectModule,
            MatChipsModule,
            MatTableModule,
            FileUploadLibraryModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            EditorModule,
            ClipboardModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibTemplateBuilderModule, { declarations: [LibTemplateBuilderComponent], imports: [PrimengLibraryModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        ImageCropperModule,
        MatIconModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        PaginatorModule,
        MultiSelectModule,
        InputTextareaModule,
        MatExpansionModule,
        ConfirmDialogModule,
        AccordionModule,
        MatDatepickerModule,
        DeleteDialogLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSelectModule,
        MatChipsModule,
        MatTableModule,
        FileUploadLibraryModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        EditorModule,
        ClipboardModule], exports: [LibTemplateBuilderComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibTemplateBuilderModule, [{
        type: NgModule,
        args: [{
                declarations: [LibTemplateBuilderComponent],
                imports: [
                    PrimengLibraryModule,
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatDialogModule,
                    ImageCropperModule,
                    MatIconModule,
                    DropdownModule,
                    DialogModule,
                    ButtonModule,
                    PaginatorModule,
                    MultiSelectModule,
                    InputTextareaModule,
                    MatExpansionModule,
                    ConfirmDialogModule,
                    AccordionModule,
                    MatDatepickerModule,
                    DeleteDialogLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatChipsModule,
                    MatTableModule,
                    FileUploadLibraryModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    EditorModule,
                    ClipboardModule
                ],
                exports: [LibTemplateBuilderComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-template-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibTemplateBuilderComponent, LibTemplateBuilderModule, LibTemplateBuilderService };
//# sourceMappingURL=lib-template-builder.js.map
